import util from '../util/util.js';
// @vite-ignore 
import * as jQuery from '../../lib/jquery/jquery-3.1.1.min.js';
const $ = jQuery;

$(document).ready(function () {
    var searchQuery = '';
    searchQuery = util.getParameter('searchQuery');
    searchQuery = decodeURIComponent(searchQuery);
    searchQuery = searchQuery.replace(/\+/g, ' ');
    if (searchQuery != '' && searchQuery !== undefined && searchQuery != 'undefined') {
        $('#textToSearch').val(searchQuery);
        $('#searchForm').submit();
    }
});

export default {};
